import { useCollectionPageHref } from "@/app/navigation/collection"
import { CollectionPageType } from "@/app/navigation/collection/collection-page-type"
import type { MinimalDrop } from "@anaconda/core/drop/types"
import { Trans } from "@lingui/react/macro"
import { cn } from "@rarible_int/anaconda_ui_components"
import Link from "next/link"

type TradeOnSecondaryLinkProps = {
  drop: MinimalDrop
  className?: string
}

export function TradeOnSecondaryLink({
  drop,
  className,
}: TradeOnSecondaryLinkProps) {
  const url = useCollectionPageHref(drop.id, CollectionPageType.ITEMS)

  return (
    <Link
      href={url}
      className={cn(
        "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-foreground bg-brand px-3 py-2 font-medium text-primary-foreground text-sm shadow transition-all duration-200 will-change-transform [backface-visibility:hidden] [transform-style:preserve-3d] hover:scale-105 hover:opacity-100 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring active:opacity-100 disabled:pointer-events-none disabled:opacity-40 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
        className,
      )}
    >
      <Trans>Trade on Secondary</Trans>
    </Link>
  )
}
